import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";
import { IAppContext } from "../model/IAppContext";
import { TheAppContext } from "../model/AppContext";
import { Smoke } from '../model/Smoke';
import { Dropdown, Option, Label, makeStyles, SelectionEvents, OptionOnSelectData } from '@fluentui/react-components';

export interface SmokeSelectDelegate
{
    (smokeId: string): void;
}

export interface SmokeChooserProps
{
    styles: Record<string, string>;
    smokes: Smoke[];
    onSelected: SmokeSelectDelegate;
    selectedSmokeId: string;
}

export interface SmokeChooserState
{
    selectedSmokeId: string;
    selectedOptionText: string;
}

const useStyles = makeStyles(
    {
        dropdown:
        {
            width: '32em'
        }
    });

export class SmokeChooserWithoutStyles extends React.Component<SmokeChooserProps, SmokeChooserState>
{
    context!: IAppContext;
    static contextType = TheAppContext;

    constructor(props: SmokeChooserProps)
    {
        super(props);
        this.state =
        {
            selectedSmokeId: this.props.selectedSmokeId,
            selectedOptionText: this.getSelectedOptionText(this.props.selectedSmokeId),
        };
    }

    componentDidUpdate(prevProps: SmokeChooserProps)
    {
        if (prevProps.selectedSmokeId !== this.props.selectedSmokeId)
        {
            this.setState(
                {
                    selectedSmokeId: this.props.selectedSmokeId,
                    selectedOptionText: this.getSelectedOptionText(this.props.selectedSmokeId),
                });
        }
    }

    getTextFromSmoke(smoke?: Smoke)
    {
        return smoke ? `${smoke.Description}(${smoke.SmokeID})` : "";
    }

    getSelectedOptionText(smokeId: string)
    {
        const smoke = this.props.smokes.find(s => s.SmokeID === smokeId);

        return this.getTextFromSmoke(smoke);
    }

    chooseSmoke(smokeId: string)
    {
        for (const smoke of this.props.smokes)
        {
            if (smoke.SmokeID === smokeId)
            {
                this.props.onSelected(smokeId);
                return;
            }
        }
    }

    onOptionSelected(event: SelectionEvents, data: OptionOnSelectData)
    {
        this.props.onSelected(data.optionValue ?? "");
    }

    render()
    {
        const options = this.props.smokes.map(
            s => (
                <Option key={s.SmokeID} value={s.SmokeID}>{this.getTextFromSmoke(s)}</Option>)
        );

        const selectedOptions = this.state.selectedSmokeId ? [this.state.selectedSmokeId] : [];
        const selectedOptionValue = this.state.selectedOptionText;

        return (
            <>
<Dropdown className={this.props.styles.dropdown}
          id="smokeChooser"
          placeholder={"Choose a smoke"}
          selectedOptions={selectedOptions}
          value={selectedOptionValue}
          onOptionSelect={this.onOptionSelected.bind(this)}>
    {options}
</Dropdown>
</>
        );
    }
}

export const SmokeChooser = withStyles(useStyles, SmokeChooserWithoutStyles);